import styled from "styled-components";

export const StyledMessages = styled.div`
  padding-top: var(--spacing-md);
`;

export const StyledMessageItem = styled.div`
  color: var(--color-text);
  margin-bottom: var(--spacing-lg);
  h3 {
    font-size: var(--font-size-md);
    font-weight: 600;
    margin-bottom: var(--spacing-xs);
    span {
      font-size: var(--font-size-sm);
      color: var(--color-text-80);
      font-weight: 400;
    }
  }
  p {
    font-size: var(--font-size-sm);
    font-weight: 400;
  }
`;
